angular.module('lf.desktop')

.directive('cartLoadingOverlay', function () {
  return {
    restrict: 'A',
    scope: true,
    link: function (scope, el, attrs) {
      var $overlay = el.find('.cart__loading-overlay');
      
      scope.$on('cart:requesting', toggle);
      scope.$on('wishlist:requesting', toggle);
      
      function toggle (e, requesting) {
        e.stopPropagation();
        if (requesting) {
          $overlay.show();
        } else {
          $overlay.hide();
        }
      }
    }
  }
});
